<template>
  <div class="home">
    <!-- <div>Home: {{uuid}}</div> -->
    <HelloWorld msg="Welcome to Your Vue.js App" :uuid="uuid" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Fingerprint2 from 'fingerprintjs2'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data() {
    return {
      uuid: '',
      app: 'asdt'
    }
  },
  created() {
    this.getUUID()
  },
  methods: {
    getUUID() {
      var options = {}
      Fingerprint2.get(options, (components) => {
        var values = components.map(function (component) {
          return component.value
        })
        var murmur = Fingerprint2.x64hash128(values.join(''), 31)
        this.uuid = murmur
        console.log(this.uuid)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  // background-color: #1E1E1E;
  width: 100%;
  height: 100%;
}
</style>